export default __webpack_public_path__ + "static/media/unauthenticated-logo.3806a3b1.svg";